import { render } from "./FastCloud.vue?vue&type=template&id=38c48890"
import script from "./FastCloud.vue?vue&type=script&lang=js"
export * from "./FastCloud.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__